import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeContext from '../../../../Context/theme/ThemeContext';

const CreateOffer = () => {
    const{theme}=useContext(ThemeContext);
    const navigate = useNavigate();
    const [OfferDetails, setOfferDetails] = useState({
        Type: '',
        Title: '',
        Price: '',
        Delivery: '',
        Description: '',
        Buyers: [''],
        files: []
    });

    const handleTypeSelection = (type) => {
        setOfferDetails(prevDetails => ({
            ...prevDetails,
            Type: type
        }));
        navigate("/user-dashboard/offer_detail", { state: { OfferDetails: type } });
    };

    return (
        <div className='flex items-center font-pop flex-col'>
            <div className={` rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4  
              ${theme==="dark"?"bg-black text-white":"bg-white"}`}>
                <h1 className='font-semibold text-xl'>Create Offer</h1>
                <div className="flex flex-col gap-4">
                    <div
                        className="flex gap-4 items-center border-2 border-light rounded-2xl py-4 px-6 cursor-pointer"
                        onClick={() => handleTypeSelection('Physical goods')}
                    >
                        <img src="../../Assets/ServiceType/PhysicalGood.png" alt="" className='w-8 h-8' />
                        <h2 className='font-medium'>Physical goods</h2>
                    </div>

                    <div
                        className="flex gap-4 items-center border-2 border-light rounded-2xl py-4 px-6 cursor-pointer"
                        onClick={() => handleTypeSelection('Digital goods')}
                    >
                        <img src="../../Assets/ServiceType/DigitalGood.png" alt="" className='w-8 h-8' />
                        <h2 className='font-medium'>Digital goods</h2>
                    </div>

                    <div
                        className="flex gap-4 items-center border-2 border-light rounded-2xl py-4 px-6 cursor-pointer"
                        onClick={() => handleTypeSelection('Services')}
                    >
                        <img src="../../Assets/ServiceType/Service.png" alt="" className='w-8 h-8' />
                        <h2 className='font-medium'>Services</h2>
                    </div>

                    <button
                        className={`py-2 px-4 rounded-full text-center w-full font-pop text-base border-2 my-4 border-lightGrey
                         ${theme==="dark"? "hover:text-white" :" hover:text-black"}`}
                        onClick={() => { }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateOffer;
